var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.6154,
    height: 0,
    transform: "translate(8 13)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29274 12.2929C6.90222 12.6834 6.90222 13.3166 7.29274 13.7071L13.6567 20.0711C14.0472 20.4616 14.6804 20.4616 15.0709 20.0711C15.4614 19.6805 15.4614 19.0474 15.0709 18.6569L9.41406 13L15.0709 7.34315C15.4614 6.95262 15.4614 6.31946 15.0709 5.92893C14.6804 5.53841 14.0472 5.53841 13.6567 5.92893L7.29274 12.2929ZM18.6152 12L7.99985 12L7.99985 14L18.6152 14L18.6152 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/previous-arrow.54e2bc625ee6cffe5f69b782afcbefee.svg";
export { ForwardRef as ReactComponent };